module.exports = __webpack_public_path__ + "ecosystem-logo.b3ba0457.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/ecosystem-logo.svg
// module id = 1422
// module chunks = 0